"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimezonePicker_1 = require("../timezonePicker/TimezonePicker");
exports.TIMEZONES = {
    "America - New York": "America/New_York",
    "America - Los Angeles": "America/Los_Angeles",
    "Europe - London": "Europe/London",
    "Europe - Berlin": "Europe/Berlin",
    "GMT+12": "Etc/GMT-12",
    "GMT+11": "Etc/GMT-11",
    "GMT+10": "Etc/GMT-10",
    "GMT+9": "Etc/GMT-9",
    "GMT+8": "Etc/GMT-8",
    "GMT+7": "Etc/GMT-7",
    "GMT+6": "Etc/GMT-6",
    "GMT+5": "Etc/GMT-5",
    "GMT+4": "Etc/GMT-4",
    "GMT+3": "Etc/GMT-3",
    "GMT+2": "Etc/GMT-2",
    "GMT+1": "Etc/GMT-1",
    "GMT-0": "Etc/GMT+0",
    "GMT-1": "Etc/GMT+1",
    "GMT-2": "Etc/GMT+2",
    "GMT-3": "Etc/GMT+3",
    "GMT-4": "Etc/GMT+4",
    "GMT-5": "Etc/GMT+5",
    "GMT-6": "Etc/GMT+6",
    "GMT-7": "Etc/GMT+7",
    "GMT-8": "Etc/GMT+8",
    "GMT-9": "Etc/GMT+9",
    "GMT-10": "Etc/GMT+10",
    "GMT-11": "Etc/GMT+11",
    "GMT-12": "Etc/GMT+12",
};
exports.TimeZonesList = (function (list) { return Object.keys(list).map(function (key) { return ({
    label: key,
    value: list[key]
}); }); })(exports.TIMEZONES);
var TimezonePickerExtended = TimezonePicker_1.default(exports.TimeZonesList);
exports.TimezonePickerExtended = TimezonePickerExtended;
exports.default = TimezonePickerExtended;
